import React, { useEffect } from "react";
import { Box, Paper, Typography } from "@mui/material";

import { useStyle } from "../../context/styleContext/styleContext";
import Seo from "../../components/Seo";
import TermsContent, {
  TERMS_EFFECTIVE_DATE,
} from "./TermsContent";

export default function Terms() {
  const { style } = useStyle();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  const termsSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Terms and Conditions | Parish Audio",
    url: "https://parishaudio.com/terms",
    description:
      "Read the Parish Audio terms and conditions for use of our website, software, downloads, accounts, subscriptions, and services.",
  };

  return (
    <>
      <Seo
        title="Terms and Conditions | Parish Audio"
        description="Read the Parish Audio terms and conditions for use of our website, plugins, downloads, accounts, subscriptions, and services."
        canonical="https://parishaudio.com/terms"
        schema={termsSchema}
      />

      <Box
        component="main"
        sx={{
          width: "100%",
          maxWidth: "100vw",
          minHeight: "calc(100vh - 130px)",
          overflowX: "hidden",
          backgroundColor: "#000",
          px: { xs: 1.25, sm: 1.5, md: 2.5 },
          py: { xs: 1.5, md: 2.5 },
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 1000,
            mx: "auto",
            minWidth: 0,
          }}
        >
          <Paper
            elevation={0}
            sx={{
              width: "100%",
              minWidth: 0,
              overflow: "hidden",
              borderRadius: "20px",
              backgroundColor: style.color1,
              backgroundImage: "none",
              border: `1px solid ${style.color2}`,
              boxShadow:
                "0 22px 55px rgba(0,0,0,0.34), inset 0 1px 0 rgba(255,255,255,0.025)",
              boxSizing: "border-box",
            }}
          >
            <Box
              sx={{
                position: "relative",
                overflow: "hidden",
                px: { xs: 1.75, sm: 2.25, md: 3 },
                py: { xs: 2, md: 2.75 },
                backgroundColor: "#111a26",
                borderBottom:
                  "1px solid rgba(255,255,255,0.08)",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  width: 220,
                  height: 220,
                  top: -145,
                  left: -80,
                  borderRadius: "50%",
                  backgroundColor: "rgba(24,146,80,0.11)",
                  filter: "blur(5px)",
                  pointerEvents: "none",
                }}
              />

              <Box sx={{ position: "relative", zIndex: 1 }}>
                <Typography
                  component="h1"
                  sx={{
                    color: style.color4,
                    fontSize: { xs: "1.85rem", md: "2.55rem" },
                    fontWeight: 900,
                    lineHeight: 1.08,
                    letterSpacing: "-0.035em",
                  }}
                >
                  Terms and Conditions
                </Typography>

                <Typography
                  sx={{
                    mt: 0.75,
                    color: style.color3,
                    fontSize: { xs: "0.85rem", md: "0.92rem" },
                  }}
                >
                  Effective date: {TERMS_EFFECTIVE_DATE}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                px: { xs: 1.75, sm: 2.25, md: 3 },
                py: { xs: 1.75, md: 2.5 },
              }}
            >
              <TermsContent />
            </Box>
          </Paper>
        </Box>
      </Box>
    </>
  );
}


// import React, { useState, useEffect, useRef } from "react";
// import { useStyle } from "../../context/styleContext/styleContext";
// import { Box, Paper, Typography, Divider, Stack } from "@mui/material";
// import Seo from "../../components/Seo";

// import TermsContent from "./TermsContent";

// export default function Terms() {
//   const { style } = useStyle();
//   const [width, setWidth] = useState(window.innerWidth);
//   const [height, setHeight] = useState(window.innerHeight);

//   useEffect(() => {
//     function handleResize() {
//       setWidth(window.innerWidth);
//       setHeight(window.innerHeight);
//     }

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "auto" });
//   }, []);

//   const isMobile = width <= 768;

//   const aboutSchema = {
//     "@context": "https://schema.org",
//     "@type": "WebPage",
//     name: "Terms and Conditions | Parish Audio",
//     url: "https://parishaudio.com/terms",
//     description:
//       "Read the Parish Audio terms and conditions for use of our website, software, downloads, accounts, subscriptions, and services.",
//   };

//   const sectionTitleSx = {
//     fontSize: { xs: "1.1rem", md: "1.25rem" },
//     fontWeight: 800,
//     color: style.color4,
//     mt: 1,
//     mb: 1,
//   };

//   const bodySx = {
//     color: style.color3,
//     lineHeight: 1.8,
//     fontSize: { xs: "0.95rem", md: "1rem" },
//     mb: 1.5,
//   };

//   const listSx = {
//     color: style.color3,
//     lineHeight: 1.8,
//     fontSize: { xs: "0.95rem", md: "1rem" },
//     pl: 3,
//     mb: 1.5,
//   };

//   return (
//     <>
//       <Seo
//         title="Terms and Conditions | Parish Audio"
//         description="Read the Parish Audio terms and conditions for use of our website, plugins, downloads, accounts, subscriptions, and services."
//         canonical="https://parishaudio.com/terms"
//         schema={aboutSchema}
//       />

//       <Box
//         sx={{
//           width: "100%",
//           maxWidth: "100vw",
//           overflowX: "hidden",
//           backgroundColor: "black",
//           px: { xs: 1.25, sm: 1.5, md: 2.5 },
//           py: { xs: 1.5, md: 2.5 },
//           boxSizing: "border-box",
//           minHeight: height - 130,
//         }}
//       >
//         <Box sx={{ width: "100%", maxWidth: 1000, mx: "auto", minWidth: 0 }}>
//           <Paper
//             elevation={0}
//             sx={{
//               width: "100%",
//               minWidth: 0,
//               borderRadius: "20px",
//               overflow: "hidden",
//               backgroundColor: style.color1,
//               border: `1px solid ${style.color2}`,
//               boxSizing: "border-box",
//             }}
//           >
//             <Box
//               sx={{
//                 px: { xs: 1.5, md: 2.25 },
//                 py: { xs: 2, md: 2.5 },
//                 backgroundColor: style.darkPanel,
//                 borderBottom: "1px solid rgba(255,255,255,0.08)",
//               }}
//             >
//               <Typography
//                 variant="h1"
//                 sx={{
//                   fontSize: { xs: "1.9rem", md: "2.6rem" },
//                   fontWeight: 800,
//                   lineHeight: 1.05,
//                   color: style.color4,
//                   letterSpacing: "-0.03em",
//                 }}
//               >
//                 Terms and Conditions
//               </Typography>

//               <Typography sx={{ ...bodySx, mt: 1, mb: 0 }}>
//                 Effective date: April 15, 2026
//               </Typography>
//             </Box>

//             <Box sx={{ px: { xs: 1.5, md: 2.25 }, py: { xs: 1.75, md: 2.25 } }}>
//               <Typography sx={bodySx}>
//                 These Terms and Conditions govern your access to and use of the
//                 Parish Audio website, software, downloadable products, accounts,
//                 subscriptions, trials, and related services. Parish Audio is
//                 operated by Brainwave LLC. By accessing the website, creating an
//                 account, purchasing a product, starting a trial, subscribing, or
//                 downloading or using our software, you agree to be bound by these
//                 Terms and Conditions. If you do not agree, do not use the website,
//                 software, or services.
//               </Typography>

//               <Typography sx={sectionTitleSx}>1. Who we are</Typography>
//               <Typography sx={bodySx}>
//                 Parish Audio is a brand operated by Brainwave LLC. References to
//                 “Parish Audio,” “Brainwave LLC,” “we,” “our,” and “us” mean
//                 Brainwave LLC and its Parish Audio business operations.
//               </Typography>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>2. Eligibility and accounts</Typography>
//               <Typography sx={bodySx}>
//                 You must provide accurate information when creating an account and
//                 keep your login credentials secure. You are responsible for
//                 activity that occurs under your account. You may not share your
//                 account with others or allow others to use your credentials to
//                 access products or services that are licensed to you.
//               </Typography>

//               <Typography sx={bodySx}>
//                 We may suspend or terminate accounts that are used fraudulently,
//                 abusively, unlawfully, or in violation of these Terms and
//                 Conditions.
//               </Typography>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>3. Software licenses</Typography>
//               <Typography sx={bodySx}>
//                 When you purchase a Parish Audio plugin, you are purchasing a
//                 license to use the software, not ownership of the software or its
//                 intellectual property. Unless otherwise stated, purchased licenses
//                 are personal, non-exclusive, non-transferable, and tied to the
//                 account used to complete the purchase.
//               </Typography>

//               <Typography sx={bodySx}>
//                 A purchased plugin license is intended to be perpetual, meaning
//                 you may continue to use the licensed version for as long as we
//                 continue to make that use reasonably available, subject to these
//                 Terms and Conditions. We do not guarantee that any product will be
//                 supported indefinitely or remain compatible with all future
//                 operating systems, DAWs, plugin formats, or hardware.
//               </Typography>

//               <Typography sx={bodySx}>
//                 Unless we state otherwise in writing, each purchased license may be
//                 activated on up to five devices at one time. You may remove old
//                 devices and authorize new ones, subject to our activation and fraud
//                 prevention controls.
//               </Typography>

//               <Typography sx={bodySx}>
//                 Subscription access and trial access are licenses for the duration
//                 of the applicable subscription or trial period only and do not
//                 create any perpetual ownership right.
//               </Typography>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>4. Subscriptions and free trials</Typography>
//               <Typography sx={bodySx}>
//                 We may offer recurring subscriptions that provide access to one or
//                 more Parish Audio products or services. We may also offer a free
//                 trial period for eligible users. If you start a free trial, your
//                 subscription will automatically convert to a paid recurring
//                 subscription unless you cancel before the trial period ends.
//               </Typography>

//               <Typography sx={bodySx}>
//                 By starting a subscription or free trial, you authorize us and our
//                 payment processor to charge your payment method for the applicable
//                 subscription fee at the end of the trial period, and again on each
//                 recurring billing date unless you cancel beforehand.
//               </Typography>

//               <Typography sx={bodySx}>
//                 Subscription pricing, billing frequency, and included products may
//                 be displayed on the checkout page or subscription page at the time
//                 of signup. You are responsible for reviewing those details before
//                 completing your subscription.
//               </Typography>

//               <Typography sx={bodySx}>
//                 You may cancel your subscription through your account on the
//                 website. If you cancel, your access continues through the end of
//                 the current paid billing period and then ends unless otherwise
//                 stated.
//               </Typography>

//               <Typography sx={bodySx}>
//                 If we materially change subscription pricing or other material
//                 subscription terms, we will provide notice to the email address
//                 associated with your account before the change takes effect.
//               </Typography>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>5. Payments and refunds</Typography>
//               <Typography sx={bodySx}>
//                 All prices are displayed in U.S. dollars unless otherwise stated.
//                 You are responsible for any taxes, duties, or charges imposed by
//                 your jurisdiction, except to the extent we are required by law to
//                 collect and remit them.
//               </Typography>

//               <Typography sx={bodySx}>
//                 Because our products are digital software products, all sales are
//                 generally final and non-refundable unless required by applicable law
//                 or approved by us in exceptional circumstances. We may consider a
//                 refund on a case-by-case basis where there is a verified technical
//                 issue that materially prevents use of the product and cannot be
//                 reasonably resolved.
//               </Typography>

//               <Typography sx={bodySx}>
//                 Subscription fees already paid are generally non-refundable, and
//                 canceling a subscription stops future renewals but does not
//                 retroactively refund prior charges, unless required by law.
//               </Typography>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>6. Activation and authorization</Typography>
//               <Typography sx={bodySx}>
//                 Parish Audio products may require account login, internet access,
//                 and authorization checks in order to activate or unlock the
//                 software. You are responsible for maintaining access to the email
//                 address and credentials associated with your account.
//               </Typography>

//               <Typography sx={bodySx}>
//                 You may not bypass, disable, interfere with, or attempt to defeat
//                 any licensing, authorization, activation, security, or access
//                 control feature used by our products or services.
//               </Typography>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>7. Acceptable use</Typography>
//               <Typography sx={bodySx}>
//                 You agree not to:
//               </Typography>
//               <Box component="ul" sx={listSx}>
//                 <li>copy, resell, sublicense, rent, lease, or redistribute our software except as expressly permitted by us;</li>
//                 <li>share account credentials or licensed access with others;</li>
//                 <li>reverse engineer, decompile, disassemble, or attempt to derive source code from our software, except where applicable law clearly permits that activity despite this restriction;</li>
//                 <li>remove or alter copyright, trademark, or proprietary notices;</li>
//                 <li>use our website or products for unlawful, fraudulent, or abusive purposes;</li>
//                 <li>interfere with the operation or security of the website, accounts, payments, licensing systems, or services.</li>
//               </Box>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>8. Reviews and user content</Typography>
//               <Typography sx={bodySx}>
//                 If you submit a review, rating, testimonial, comment, or other
//                 content through our website, you represent that it is accurate to
//                 the best of your knowledge, does not violate the rights of others,
//                 and does not contain unlawful, threatening, defamatory, obscene, or
//                 abusive material.
//               </Typography>

//               <Typography sx={bodySx}>
//                 We may moderate, screen, reject, or remove reviews or other
//                 submitted content in our discretion, including for profanity,
//                 abuse, spam, fraud, or violations of these Terms and Conditions.
//               </Typography>

//               <Typography sx={bodySx}>
//                 By submitting content to the website, you grant us a non-exclusive,
//                 worldwide, royalty-free license to use, display, reproduce, and
//                 publish that content in connection with our website, products,
//                 services, and marketing, subject to our Privacy Policy and
//                 applicable law.
//               </Typography>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>9. Intellectual property</Typography>
//               <Typography sx={bodySx}>
//                 The website, software, branding, product names, graphics, audio,
//                 code, text, downloads, and other content made available by Parish
//                 Audio are owned by Brainwave LLC and/or its licensors and are
//                 protected by copyright, trademark, and other intellectual property
//                 laws. Except for the limited license rights expressly granted in
//                 these Terms and Conditions, no rights are granted to you.
//               </Typography>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>10. Software updates, support, and availability</Typography>
//               <Typography sx={bodySx}>
//                 We may release updates, fixes, improvements, or changes to our
//                 products and services at any time. We are not obligated to provide
//                 any particular update, feature, compatibility fix, or support term
//                 unless we expressly say otherwise.
//               </Typography>

//               <Typography sx={bodySx}>
//                 We do not guarantee uninterrupted availability of the website,
//                 downloads, account services, or licensing systems. Temporary
//                 downtime, maintenance, third-party service outages, or technical
//                 issues may occur.
//               </Typography>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>11. Disclaimers</Typography>
//               <Typography sx={bodySx}>
//                 To the maximum extent permitted by applicable law, the website,
//                 software, downloads, and services are provided “as is” and “as
//                 available,” without warranties of any kind, whether express,
//                 implied, or statutory, including implied warranties of
//                 merchantability, fitness for a particular purpose, title, and
//                 non-infringement.
//               </Typography>

//               <Typography sx={bodySx}>
//                 We do not warrant that the website, software, or services will be
//                 uninterrupted, error-free, secure, or compatible with every system,
//                 host, DAW, configuration, or future environment.
//               </Typography>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>12. Limitation of liability</Typography>
//               <Typography sx={bodySx}>
//                 To the maximum extent permitted by applicable law, Brainwave LLC,
//                 Parish Audio, and their owners, affiliates, licensors, service
//                 providers, and representatives will not be liable for any indirect,
//                 incidental, special, consequential, exemplary, or punitive damages,
//                 or for any loss of profits, revenue, data, goodwill, use, business
//                 opportunity, or business interruption arising out of or related to
//                 your use of the website, software, downloads, subscriptions, or
//                 services.
//               </Typography>

//               <Typography sx={bodySx}>
//                 To the maximum extent permitted by applicable law, our total
//                 liability for any claim arising out of or relating to the website,
//                 software, subscriptions, or services will not exceed the amount you
//                 paid to us for the specific product or subscription giving rise to
//                 the claim during the twelve months before the event giving rise to
//                 the claim.
//               </Typography>

//               <Typography sx={bodySx}>
//                 Nothing in these Terms and Conditions excludes or limits liability
//                 to the extent that such liability cannot be excluded or limited
//                 under applicable law.
//               </Typography>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>13. Termination</Typography>
//               <Typography sx={bodySx}>
//                 We may suspend or terminate your access to the website, account,
//                 software, downloads, or services if we reasonably believe you have
//                 violated these Terms and Conditions, engaged in fraud or abuse,
//                 attempted to circumvent licensing restrictions, or created risk or
//                 harm for us, our users, or our service providers.
//               </Typography>

//               <Typography sx={bodySx}>
//                 Sections that by their nature should survive termination will
//                 survive, including sections relating to payments, licenses,
//                 intellectual property, disclaimers, limitation of liability, and
//                 dispute terms.
//               </Typography>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>14. Privacy</Typography>
//               <Typography sx={bodySx}>
//                 Your use of the website, software, and services is also subject to
//                 our Privacy Policy. Please review the Privacy Policy to understand
//                 how we collect, use, and disclose information.
//               </Typography>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>15. Governing law</Typography>
//               <Typography sx={bodySx}>
//                 These Terms and Conditions and any dispute arising out of or
//                 relating to them, the website, the software, or the services will
//                 be governed by the laws of the State of Idaho, without regard to
//                 conflict of law principles.
//               </Typography>

//               <Typography sx={bodySx}>
//                 Unless applicable law requires otherwise, any legal action arising
//                 out of or relating to these Terms and Conditions must be brought in
//                 a state or federal court located in Idaho, and you consent to the
//                 personal jurisdiction and venue of those courts.
//               </Typography>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>16. Changes to these terms</Typography>
//               <Typography sx={bodySx}>
//                 We may update these Terms and Conditions from time to time. When we
//                 do, we will update the effective date at the top of this page.
//                 Changes will become effective when posted, unless otherwise
//                 required by law or otherwise stated by us. Your continued use of
//                 the website, software, or services after updated terms are posted
//                 means you accept the revised terms.
//               </Typography>

//               <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.08)" }} />

//               <Typography sx={sectionTitleSx}>17. Contact</Typography>
//               <Typography sx={bodySx}>
//                 If you have questions about these Terms and Conditions, please
//                 contact:
//               </Typography>

//               <Stack spacing={0.35} sx={{ mb: 2 }}>
//                 <Typography sx={{ color: style.color4, fontWeight: 700 }}>
//                   Brainwave LLC / Parish Audio
//                 </Typography>
//                 <Typography sx={{ color: style.color3 }}>
//                   Email: support@parishaudio.com
//                 </Typography>
//               </Stack>
//             </Box>
//           </Paper>
//         </Box>
//       </Box>
//     </>
//   );
// }